export default __webpack_public_path__ + "static/media/211.2572e27a.jpg";